import React from 'react';
import Navbar from './Navbar';
import Cookies from '../../../lib_react_frontend/utils/Cookies';


export default (props) => (
  <header className='main-header'>

    <a href={props.rota} className='logo' >
      {/* O Logo pequeno: */}
      <span className='logo-mini'>
        {props.tituloPequeno}
      </span>

      {/* O Logo grande com ícone: */}

      <span className='logo-lg' >
        {props.icon && <i className={'fa rxzz ' + props.icon} />}
        <span style={{ marginLeft: '5px' }} />
        {props.tituloGrande}
      </span>
    </a>

    {/* A Barra: */}

    <nav className='navbar navbar-static-top' >

      {props.escondeSidebar ? null :
        <a className='sidebar-toggle' data-toggle='offcanvas' />}
      {props.escondeUser ? null :

        <Navbar options={props.options}
          options={props.tituloPequeno}
          onLogout={props.onLogout} />
      }

      {global.exibiFantasia ?
        <div className="titulo-nome-fatansia" style={{ color: 'black', textAlign: 'left', marginTop: '-7px' }}>
          <h3>{Cookies.get('condominio') ? Cookies.get('condominio').nome_empresa : 
            props.dados_empresa ? props.dados_empresa.nome_empresa : ''}</h3>
        </div> : null}

    </nav>
  </header>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/header/Header.jsx